'use client';

import { useTranslation } from '@/contexts/dictionaryContext';
import useFilterContext from '@/hooks/useFilterContext';
import { useLocale } from '@/hooks/useLocale';
import useUserContext from '@/hooks/useUserContext';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { buttonVariants } from '../Button';
import Select, { SelectOption } from '../Select';

type Props = {
  className?: string;
  writeReviewHref: string;
};

export default function ReviewsSectionFilterAndAnchor({
  className,
  writeReviewHref,
}: Props) {
  const { village: dict } = useTranslation();
  const lang = useLocale();

  const { allLanguages, writeAReview, filterByLanguage } = dict.reviewsSection;

  const options = [
    { label: allLanguages, value: 'all' },
    { label: 'Italiano', value: 'it' },
    { label: 'English', value: 'en' },
    { label: 'Français', value: 'fr' },
    { label: 'Deutsch', value: 'de' },
  ];

  const [selectedLang, setSelectedLang] = useState(options[0]);
  const { setReviewsLanguageFilter } = useFilterContext();
  const { isLogged } = useUserContext();

  function handleOnChange(value: SelectOption) {
    setSelectedLang(value);
    setReviewsLanguageFilter(value.value);
  }

  function getCustomerSectionLink() {
    let locale = lang === 'en' ? '' : `/${lang}`;

    if (isLogged) {
      return `${process.env.NEXT_PUBLIC_VT_LEGACY_URL}${locale}/customer/${writeReviewHref}`;
    } else {
      return `${locale}/login`;
    }
  }

  return (
    <div
      className={cn(
        'flex-[0_0_auto] w-full md:flex md:flex-wrap md:justify-between  mt-8 desktop:w-1/3 desktop:mt-0 desktop:text-right desktop:justify-end',
        className,
      )}>
      <div className="text-left w-full md:max-w-[220px]">
        <Select
          label={filterByLanguage}
          id="filter"
          onChange={handleOnChange}
          options={options}
          selectedValue={selectedLang}
        />
      </div>
      <div className="mt-4 desktop:ml-[60px]">
        <a
          className={cn(
            buttonVariants({ variant: 'default', size: 'default' }),
            'desktop:w-auto',
          )}
          target="_blank"
          href={getCustomerSectionLink()}>
          {writeAReview}
        </a>
      </div>
    </div>
  );
}
